import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  IUndoActionSnackBarData,
  UndoActionSnackBarComponent,
} from './undo-action-snack-bar.component';

export interface IUndoActionSnackBarConfig {
  message: string;
  actionLabel?: string;
  duration?: number;
}

export interface IUndoActionSnackBarResult {
  afterDismissed$: Observable<{ undone: boolean }>;
  dismiss: () => void;
}

@Injectable({ providedIn: 'root' })
export class UndoActionSnackBarService {
  private readonly _snackBar = inject(MatSnackBar);

  open(config: IUndoActionSnackBarConfig): IUndoActionSnackBarResult {
    const duration = Math.max(config.duration ?? 5000, 1000);
    const ref = this._snackBar.openFromComponent(UndoActionSnackBarComponent, {
      data: {
        message: config.message,
        actionLabel: config.actionLabel,
        duration,
      } as IUndoActionSnackBarData,
      duration: 0,
      panelClass: 'undo-action-snack-bar',
    });

    return {
      afterDismissed$: ref
        .afterDismissed()
        .pipe(map((info) => ({ undone: info.dismissedByAction }))),
      dismiss: () => ref.dismiss(),
    };
  }
}
